export const findWidget = (widgets, widgetName) => {
  const widget = widgets?.find((item) => item.type === widgetName);

  return widget;
};
